import BaseService from '@/services/BaseService'
import Permission, { Category } from '@/models/permission'
import Permissions from '@/models/constants/Permissions'

export class PermissionService extends BaseService<Permission> {
  constructor() {
    super('permissions/')
  }

  public async getPermissionsCategories(): Promise<Category[]> {
    const result = await this.instance.get<Category[]>(
      this.resourcePath + 'categories/',
    )
    return result.data
  }

  public async updatePermissions(permissions: Set<Permission>): Promise<Category[]> {
    const result = await this.instance.put<Category[]>(
      this.resourcePath + 'update-permissions/',
      { permissions },
    )
    return result.data
  }

  public async getDefaultPermissionId() {
    const result = await this.get()

    let found: boolean = false
    let i: number = 0
    const length: number = result.length - 1

    do {
      const permission = result[i]
      if (permission.code_name === Permissions.Authenticate) {
        found = true
      }

      i++
    } while (!found && i < length)
    return [result[i - 1].id] as number[]
  }
}

export default new PermissionService()
